export const CLASSTING_AUTH_URL = process.env.REACT_APP_AUTH_URL
export const CLASSTING_CLIENT_ID = process.env.REACT_APP_CLIENT_ID
export const CLASSTING_REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI

export const CLASSTING_COMPLETE_AUTH_URL = `${CLASSTING_AUTH_URL}/authorize?client_id=${CLASSTING_CLIENT_ID}&scope=public_profile&response_type=token&redirect_uri=${window.location.href}`
